<template>
    <section id="FoundryImagery" :class="$style.foundryImagery">
        <section :class="$style.foundryInfoHeading">
            <div :class="$style.imageHeadingInfo">
                <MdTypography data-qa-id="foundryImageryHeading" tag="h3" variant="heading7--medium">
                    {{$t('pages.profile.imageheading')}}
                </MdTypography>
                <InfoIcon fill="#C3CAD4" width="21" height="21" @click="showOverlayInfoFunc('foundryImagery')"/>
            </div>
            <MdTypography data-qa-id="foundryImageryPara" tag="p" color="spirits--700" variant="body2--regular">
                {{$t('pages.profile.imagepara')}}
            </MdTypography>
        </section>

        <section :class="$style.imageUploaderWrapper">
            <div :class="$style.avStatusDiv">
                <template v-if="getAvScanStatus.status !== ''">
                    <fou-group v-if="getAvScanStatus.status === 'scanning'">
                      <span :class="$style.scanningMalware"></span>
                      <MdTypography :class="$style.malwareText" tag="span" variant="body2--medium" color="spirits--700">
                        {{$t('malwareScan.scanInitiationMessage')}}
                      </MdTypography>
                    </fou-group>
                    
                    <fou-group v-if="getAvScanStatus.status == true">
                      <span :class="$style.successMalwareIcon"></span>
                      <MdTypography :class="$style.malwareText" tag="span" variant="body2--medium" color="spirits--700">
                        {{$t('malwareScan.scanCompletionMessage')}}
                      </MdTypography>
                    </fou-group>
                    
                    <fou-group v-else-if="getAvScanStatus.status == false">
                      <span :class="$style.malwareIcon"></span>
                      <MdTypography :class="$style.malwareText" tag="span" variant="body2--medium" color="spirits--700">
                        {{$t('malwareScan.malwareDetectionMessageForRemovedFiles')}}
                        <MdLink href="mailto:foundrysupport@monotype.com" target="_blank" rel="noopener noreferrer" color="blue" underline="false" variant="none">
                            {{$t('pages.submissions.components.upload.fontmeta.designers.email')}}
                        </MdLink>. {{getAvScanStatus.name}}
                      </MdTypography>
                    </fou-group> 
                  </template>
            </div>
            <div :class="$style.imageBannerBackground">
                <span :class="$style.imageBackground" v-if="resourceLocBanner" :style="{ backgroundImage: `url(${resourceLocBanner})` }"></span>
                <span v-else-if="!resourceLocBanner && bannerProcessing" :class="$style.animationWrapper">
                    <AnimationProcessing width="50px"/>
                </span>
                <span v-else :class="$style.imageBackground" :style="{ backgroundImage: `url(${defaultBannerUrl})`}"></span>
                <div :class="$style.emptyBannerDropdown" v-if="!resourceLocBanner">
                    <MdIconExport color="blue-duck--500" />
                    <MdTypography :class="$style.uploadImageText" tag="p" variant="body2--medium">
                        {{$t('pages.profile.imageuploadtext')}}
                    </MdTypography>
                </div>
                <div :class="$style.imageBannerDropdown" ref="bannerDropdown" v-else>
                    <div :class="$style.editBanner" @click="toggleBannerDropdown" ref="bannerEdit">
                        <!-- <Upload /> -->
                        <MdIconExport color="blue-duck--500" />
                        <MdTypography :class="$style.uploadImageText" tag="p" variant="body2--medium">
                            {{$t('pages.profile.imageedittext')}}
                        </MdTypography>
                        <Arrow :class="$style.arrow" :showBanner="showBannerDropdown" />
                    </div>
                    <div :class="$style.imageBanner" v-if="showBannerDropdown">
                        <ul :class="$style.imageBannerList" ref="bannerList">
                            <li>
                                <MdIconExport color="spirits--700" />
                                {{$t('pages.profile.new_foundry.change_image')}}
                                <input id="file-upload" type="file" name="foundry-info-banner" class="mt-input"
                                    accept=".png, .jpg, .jpeg" :value="files" data-qa-id="file-upload"
                                    title="foundry-info-banner" :disabled="loadingBanner" @change="event => upload(event, 2)">
                            </li>
                            <li @click="emitToDelete('deleteBanner')">
                                <Delete />
                                {{$t('pages.profile.new_foundry.delete')}}
                            </li>
                        </ul>
                    </div>
                </div>
                <input v-if="!resourceLocBanner" id="file-upload" type="file" name="foundry-info-banner"
                    class="mt-input" accept=".png, .jpg, .jpeg" :value="files" data-qa-id="file-upload"
                    title="foundry-info-banner" :disabled="loadingBanner" :class="$style.imageUploadBanner"
                    @change="event => upload(event, 2)">
            </div>
            <div :class="$style.imageLogoBackground">
                <span v-if="resourceLocLogo" :class="$style.imageLogoSpan"
                    :style="{ backgroundImage: `url(${resourceLocLogo})` }" />
                <span v-else-if="!resourceLocLogo && logoProcessing" :class="$style.animationWrapper">
                    <AnimationProcessing width="24px"/>
                </span>
                <span :class="[$style.currentFoundryInitial]" v-else>{{ name?.split(' ').map(word =>
                    word.charAt(0)).join('')
                    || '' }}</span>
                <div :class="$style.emptyLogoDropdown" @click="toggleLogoDropdown" ref="logoEdit">
                    <MdIconEdit />
                </div>
                <div :class="$style.imageLogo" v-if="showLogoDropdown && resourceLocLogo">
                    <ul :class="$style.imageLogoList" ref="logoList">
                        <li>
                            <MdIconExport color="spirits--700" />
                            {{$t('pages.profile.new_foundry.change_image')}}
                            <input id="file-upload" type="file" name="foundry-info-logo" class="mt-input"
                                accept=".png, .jpg, .jpeg" :value="files" data-qa-id="file-upload"
                                title="foundry-info-logo" :disabled="loadingLogo" @change="event => upload(event, 1)">
                        </li>
                        <li @click="emitToDelete('deleteLogo')">
                            <MdIconEmptyTrash color="spirits--700" />
                            {{$t('pages.profile.new_foundry.delete')}}
                        </li>
                    </ul>
                </div>
                <input v-if="!resourceLocLogo" id="file-upload" type="file" name="foundry-info-logo" class="mt-input"
                    accept=".png, .jpg, .jpeg" :value="files" data-qa-id="file-upload" title="foundry-info-logo"
                    :disabled="loadingLogo" @change="event => upload(event, 1)">
            </div>
        </section>
        <MdTypography :class="$style.foundryName" variant="heading6--medium">
            {{name}}
        </MdTypography>
    </section>

    <section v-if="showImageCropper">
        <CropperImage :image="imageCropper" :fileName="imageCropperName" :priority="setPriority" @set:Image="setUploadedImage" @hide:Cropper="hideCropperModal">
            <template #title>
                <MdTypography id="modal-title" data-qa-id="modal-title" v-if="setPriority === 1" tag="span" variant="heading6--medium">
                    {{$t('pages.profile.new_foundry.cropper_foundry_logo')}}
                </MdTypography>
                <MdTypography id="modal-title" data-qa-id="modal-title" v-else tag="span" variant="heading6--medium">
                    {{$t('pages.profile.new_foundry.cropper_foundry_banner')}}
                </MdTypography>
              </template>
        </CropperImage>
    </section>
</template>
